import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import moment from "moment";
import { getAllFacultyOnly } from "../../api/dashboardApi";
import { ToastContainer, toast } from "react-toastify";
import NoPermission from "../../common/NoPermission";
import Popup from "../../Shared/Popup";
import ViewDetailedProfile from "./ViewDetailedProfile";
import { Modal, FormControl, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { departmentList } from "../../common/DepartmentsList";
import { Field, Form, FormikProvider, useFormik } from "formik";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40vw",
  bgcolor: "white",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
  boxSizing: "content-box",
};
export default function AllFaculties({ permissions = {}, isSuperAdmin }) {
  const dispatch = useDispatch();
  const [openEventPopup, setopenEventPopup] = useState(false);
  const [customPopupTitle, setcustomPopupTitle] = useState("");
  const [customPopupContent, setcustomPopupContent] = useState();
  const getFaculty = (e) => dispatch(getAllFacultyOnly(e));
  const state = useSelector((state) => state);
  const {
    dashboardReducer: {
      allFaculty = [],
      facultyLoaing,
      verifyApiCalled,
      verificationSuccess,
    } = {},
  } = state;

  const [facultyId, setFacultyId] = useState("");
  const [name, setName] = useState("");
  const [department, setDepartment] = useState("");

  const d = moment(new Date()).format("yyyy-MM-DD");

  useEffect(() => {
    getFaculty(d);
  }, []);

  const onButtonClick = () => {
    console.log("filter api call here");
    console.log("faculty id", facultyId);
    console.log("name", name);
    console.log("department", department);
    // const searchErrorCallback = () =>
    //   toast.error("Error Occured. Please try again...", {
    //     position: "top-right",
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     draggable: false,
    //     progress: undefined,
    //   });
    // const callbacks = {
    //   searchErrorCallback,
    //   fetchProfile: true,
    // };
    // clearFlags();
    // verifyAndSearchUser(facultyId, callbacks);
  };

  if (!isSuperAdmin && !permissions.read) {
    return <NoPermission />;
  }
  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="header-action">
                <h1 className="page-title">All faculties</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All faculties
                  </li>
                </ol>
              </div>
            </div>
            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Select Date"
              inputFormat="yyyy/MM/dd"
              value={d}
              // onChange={(date) => onDateCange(date)}
              maxDate={new Date()}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{ width: "20%", outline: "none" }}
                  helperText={null}
                />
              )}
              // shouldDisableDate={disableDates}
            />
          </LocalizationProvider> */}
          </div>
        </div>
      </Fragment>
    );
  };
  const renderFilters = () => {
    return (
      <Fragment>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div className="col-md-4">
            <label className="col-md-3 col-form-label" style={{whiteSpace:"nowrap"}}>Faculty Id</label>
            <input
              className="form-control"
              type="text"
              placeholder="Faculty Id"
              value={facultyId}
              onChange={(e) => setFacultyId(e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <label className="col-md-3 col-form-label" style={{whiteSpace:"nowrap"}}>Name</label>
            <input
              className="form-control"
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value.toLowerCase())}
            />
          </div>
          <div className="col-md-4">
            <label className="col-md-3 col-form-label" style={{whiteSpace:"nowrap"}}>Department</label>
            <select
              className="form-control"
              type="select"
              placeholder="Department"
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
            >
              <option value="---">---</option>
              {departmentList.map((val, index) => {
                return (
                  <option key={`${val}_${index}`} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div style={{ paddingLeft: "10px", paddingTop: "20px" }}>
          <button
            id="search-user-btn"
            className="btn btn-primary col-md-2"
            type="button"
            onClick={onButtonClick}
          >
            {" "}
            Apply filter(s)
          </button>
        </div>
      </Fragment>
    );
  };
  return (
    <Fragment>
      {renderHeader()}

      <div className="section-body mt-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Filters:</h3>
                </div>
                <div
                  style={{
                    paddingLeft: "20px",
                    paddingBottom: "20px",
                    paddingRight: "20px",
                  }}
                >
                  {renderFilters()}
                </div>
                <div className="table-responsive card" style={{width:"98%", alignSelf:"center"}}>
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th>S. No.</th>
                        <th>Name</th>
                        <th></th>
                        <th>Department</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>College Id</th>
                        <th>More details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!facultyLoaing &&
                        allFaculty.map((faculty, i) => {
                          return (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td className="w60">
                                <img
                                  className="avatar"
                                  src={faculty.profile_picture}
                                  alt=""
                                />
                              </td>
                              <td>
                                <span className="font-16">
                                  {faculty?.full_name?.first_name}{" "}
                                  {faculty?.full_name?.last_name}
                                </span>
                              </td>
                              <td>{faculty.department}</td>
                              <td>{faculty.email_id}</td>
                              <td>{faculty.mobile_number}</td>
                              <td>{faculty.faculty_id}</td>
                              <td>
                                <span
                                  className="text-primary"
                                  onClick={() => {
                                    setcustomPopupTitle(
                                      `Detailed profile for: ${faculty.full_name.first_name} ${faculty.full_name.last_name}`
                                    );
                                    setcustomPopupContent(
                                      <ViewDetailedProfile
                                        userProfile={faculty}
                                      />
                                    );
                                    setopenEventPopup(true);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  View
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                  <Modal
                    open={openEventPopup}
                    onClose={() => {
                      setcustomPopupTitle("");
                      setcustomPopupContent({});
                      setopenEventPopup(false);
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={modalStyle}>
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        {customPopupTitle}
                      </Typography>
                      <hr />
                      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                          {customPopupContent}
                        </FormControl>
                      </Typography>
                    </Box>
                  </Modal>
                  {facultyLoaing && (
                    <div style={{ textAlign: "center" }}>
                      <i className="fa fa-circle-o-notch fa-spin fa-fw mr-2"></i>
                      Loading Faculty...
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}

